'use client';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { cn } from 'utils/cn';
import Entering from './Entering';
import Typography from './Typography';

interface ICardsGrid {
  cards?: {
    title: string | ReactNode;
    icon?: ReactNode;
    description?: string;
  }[];
  height?: number | string;
  fontSize?: number;
  gridCols?: string;
  alignCenter?: boolean;
}

const CardsGrid: FC<PropsWithChildren<ICardsGrid>> = ({
  cards = [],
  height = 278,
  gridCols = 'grid-cols-1 lg:grid-cols-3',
  fontSize = 24,
  alignCenter
}) => (
  <div className="flex justify-center">
    <div className={cn('grid gap-8', gridCols)}>
      {cards?.map(({ title, icon, description }, index) => (
        <Entering
          initial={false}
          damping={20}
          mass={0.5}
          stiffness={120}
          delay={index * 0.2}
          key={description}
          className={cn(
            'h-full rounded-6xl border border-tolq-gray-100 bg-white p-6',
            `lg:${height}px`
          )}
        >
          {icon}
          <div className="py-3">
            <Typography
              variant="bold4xl"
              className="!text-center text-tolq-black-100"
              style={{ fontSize }}
            >
              {alignCenter ? (
                <div className="flex flex-col items-center justify-center text-center">{title}</div>
              ) : (
                <>{title}</>
              )}
            </Typography>
          </div>
          <div>
            <Typography variant="light3" className="text-tolq-black-200">
              {alignCenter ? <div className="text-center ">{description}</div> : <>{description}</>}
            </Typography>
          </div>
        </Entering>
      ))}
    </div>
  </div>
);

export default CardsGrid;
